<mat-form-field>
  <mat-icon matPrefix>search</mat-icon>
  <input matInput #inputRef type="text" placeholder="search" (input)="onInput(inputRef.value)" (keydown.enter)="enterPressed.emit()" />
  <button mat-icon-button matSuffix (click)="clearSearch()">
    <mat-icon>highlight_off</mat-icon>
  </button>
</mat-form-field>

